// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import VueResource from 'vue-resource'
import { Picker, Popup } from 'mint-ui';
import Header from './components/Header.vue'
import 'mint-ui/lib/style.css';
import VueClipboard from 'vue-clipboard2'

// import axios from 'axios'
Vue.use(VueClipboard)
// Vue.prototype.$http = axios
Vue.config.productionTip = false
Vue.use(VueResource)
Vue.component(Picker.name, Picker);
Vue.component(Popup.name, Popup);
Vue.component('mm-header',Header)


Vue.http.options.xhr = { withCredentials: true };


Vue.http.interceptors.push(function (request, next) {//拦截器
  // 携带cookie
  request.credentials = true;
  next()
})

!(function (win, doc) {
  function setFontSize() {
    var winWidth = doc.documentElement.clientWidth;
    doc.documentElement.style.fontSize = (winWidth / 1080) * 100 + 'px';
  }
  var evt = 'onorientationchange' in win ? 'orientationchange' : 'resize';
  var timer = null;
  win.addEventListener(evt, function () {
    clearTimeout(timer);
    timer = setTimeout(setFontSize, 300);
  }, false);
  setFontSize();
}(window, document));

// !function (doc, win, designWidth, rem2px) {
//   var docEl = doc.documentElement,
//     defaultFontSize = /*adapt(designWidth, rem2px),*/16,
//     resizeEvt = 'orientationchange' in window ? 'orientationchange' : 'resize',
//     recalc = function () {
//       var clientWidth = win.innerWidth
//         || doc.documentElement.clientWidth
//         || doc.body.clientWidth;

//       if (!clientWidth) return;

//       docEl.style.fontSize = clientWidth / designWidth * rem2px / defaultFontSize * 100 + '%';


//     };
//   if (!doc.addEventListener) return;
//   win.addEventListener(resizeEvt, recalc, false);
//   doc.addEventListener('DOMContentLoaded', recalc, false);
// }(document, window, 1080, 100);

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: { App }
})





// WEBPACK FOOTER //
// ./src/main.js